import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

import { PRIMARY_LIGHT, SECONDARY, ERROR } from '../constants/colors';

export class LineChartComponent extends Component {
  sortMeasurements(a, b) {
    if (a.name > b.name) {
      return -1;
    } else if (a.name < b.name) {
      return 1;
    }
    return 0;
  }

  render() {
    const { measurements, width, height } = this.props;

    return (
      <LineChart
        data={measurements.sort(this.sortMeasurements)}
        height={height}
        margin={{
          top: 5, right: 30, left: 20, bottom: 5,
        }}
        width={width}
      >
        <XAxis allowDuplicatedCategory={false} dataKey="name" />
        <YAxis />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend />
        <Line
          dataKey="RL"
          stroke={PRIMARY_LIGHT}
          type="monotone"
        />
        <Line
          dataKey="QD"
          stroke={SECONDARY}
          type="monotone"
        />
        <Line
          dataKey="RW"
          stroke={ERROR}
          type="monotone"
        />
      </LineChart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LineChartComponent.js